import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn3() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`III.`}
            <br />
            {`Conclusion of an Agreement`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`The proposal to conclude an Agreement for the provision of access to the service shall be made by the User by filling in the data in the registration form of the User account, agreeing to these terms and conditions and sending this data to the Provider (hereinafter the "order").`}</li>
            <li>{`After delivery of the order and payment for the relevant service or the first period of the service, the Provider will allow the User access to the website, i.e. access to the selected content.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={3} className={sList}>
            <li>{`The Provider is entitled to reject the User's order, especially for persons who have previously materially breached an Agreement with the Provider or these terms and conditions.`}</li>
            <li>{`The Provider is entitled to assign the rights and obligations under the Agreement to a third party, even without the consent of the User.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn3;
